/**
 * Utility to detect if we're in a prerendering environment (react-snap)
 */

export const isPrerendering = () => {
  if (typeof navigator === 'undefined') return true;
  return navigator.userAgent.includes('ReactSnap');
};

export const isServer = () => {
  return typeof window === 'undefined';
};
